import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { UIService } from './services/ui/ui.service';
import { AuthService } from './services/auth/auth.service';
import { StatusService } from './services/user/status.service';
import { HttpService } from './services/base/http.service';
import { UserService } from './services/user/user.service';
import { LoginGuard } from '../auth/guard/login.guard';
import { RoleService } from './services/user/role.service';
import { ReportTemplateService } from './services/report/report-template.service';
import { ClientService } from './services/client/client.service';
import { FileUploadService } from './services/user/file-upload.service';
import { PasswordService } from './services/user/password.service';
import { WorkVoucherService } from './services/report/work-voucher.service';
import { WorkSheetService } from './services/report/work-sheet.service';
import { EntityService } from './services/entity/entity.service';
import { RecordService } from './services/entity/record.service';
import { ReportDraftStorageService } from './services/report/report-draft-storage.service';

@NgModule({
    providers: [
        UIService,
        AuthService,
        StatusService,
        HttpService,
        UserService,
        LoginGuard,
        RoleService,
        ReportTemplateService,
        ClientService,
        EntityService,
        RecordService,
        FileUploadService,
        PasswordService,
        WorkVoucherService
        ,
        WorkSheetService
        ,
        ReportDraftStorageService
    ],
    declarations: [],
    exports: [],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CoreModule { }
